"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _listDividerModule = _interopRequireDefault(require("./list-divider.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ListDivider = function ListDivider(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("hr", {
    className: (0, _classnames["default"])(_listDividerModule["default"].listDivider, className)
  });
};

ListDivider.propTypes = {
  className: _propTypes["default"].string
};
ListDivider.defaultProps = {
  className: ''
};
var _default = ListDivider;
exports["default"] = _default;